angular.module('am4')
.factory('ecofitService', function($http, apiUrl) {
    return {
        getFacilityEcofitData: function(facility_id) {
            return $http.get(apiUrl + '/facilities/' + facility_id + '/ecofit')
            .then(function(res) {
                return res.data;
            });
        },
        upsertFacilityEcofitData: function(facility_id, body) {
            return $http.post(apiUrl + '/facilities/' + facility_id + '/ecofit', body)
            .then(function(res) {
                return res.data;
            });
        }
    };
});


// WEBPACK FOOTER //
// ./src/app/services/ecofit.js